import Swiper from 'swiper/bundle';
export default class CarouselMansory {
    constructor() {

        this.carousel = {
            element: document.querySelector('.carousel[data-carousel="mansory"]'),
        }

        this.createCarousel(this.carousel.element); // Init Carousel
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            grabCursor: true,
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
            scrollbar: {
                el: ".carousel--scrollbar",
                draggable: true,
            },
            breakpoints: {
                1200 : {
                    spaceBetween: 30,
                }
            }
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}